module.exports = __webpack_public_path__ + "static/media/logo_coally_plf.cea4e5eb.jpeg";